import { render, staticRenderFns } from "./DoctorsModuleComponent.vue?vue&type=template&id=75f150c3&scoped=true"
import script from "./DoctorsModuleComponent.vue?vue&type=script&lang=js"
export * from "./DoctorsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./DoctorsModuleComponent.vue?vue&type=style&index=0&id=75f150c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f150c3",
  null
  
)

export default component.exports